var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbBunnyRightBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.88 411.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b4ad1044-599e-4d0e-806a-9c8b46d8c038{fill:#fff;}.a8219468-038b-403c-92a1-27748d291097,.e20d0547-7f8a-47ae-b56d-c2edf5c3e713{fill:#046fb5;}.e20d0547-7f8a-47ae-b56d-c2edf5c3e713{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc1bc62c-d31b-42fa-98b2-987b1faf32ab",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e3464911-bcbe-4270-b4e1-ace71fa9571c",
    "data-name": "tubes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4ad1044-599e-4d0e-806a-9c8b46d8c038",
    d: "M401.88,2.5A409,409,0,0,0,34.65,252C13.32,302.38,2.5,351.9,2.5,407v4.67h160V407c0-66.41,25.86-124.85,72.82-171.81a246.9,246.9,0,0,1,166.56-72.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8219468-038b-403c-92a1-27748d291097",
    d: "M401.88,5V0A411.52,411.52,0,0,0,32.34,251C10.28,303.14,0,352.73,0,407v4.67H5V407c0-53.61,10.15-102.58,32-154.11A405.83,405.83,0,0,1,401.88,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8219468-038b-403c-92a1-27748d291097",
    d: "M401.88,160.07a249.35,249.35,0,0,0-168.32,73.38C209.72,257.28,191.37,284,179,312.84A237.68,237.68,0,0,0,160,407v4.67h5V407a232.75,232.75,0,0,1,18.6-92.22c12.11-28.26,30.11-54.44,53.49-77.82a244.4,244.4,0,0,1,164.79-71.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e20d0547-7f8a-47ae-b56d-c2edf5c3e713",
    d: "M401.88,112.1c-24.16.55-76.25,5.1-130.1,31.3-42.9,20.87-78,51.08-104.48,89.81-32.47,47.56-51.45,107.29-56.43,178.49l49.88-.14c4.31-61.71,20.94-106.33,47.92-146.32A214.42,214.42,0,0,1,292.26,192c45.09-22.39,89.62-28,109.62-29.43Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbBunnyRightBottom);
export default __webpack_public_path__ + "static/media/BB-BunnyRightBottom.ab2a8f50c8fae789a03a5701e6bd6448.svg";
export { ForwardRef as ReactComponent };